/// <reference path="../../global/fn.js" />

(function ($) {
    jQuery.widget("nsp.w_stickyLnks", {
        options: {},
        _setOption: function (key, value) {
            this.options[key] = value;
            this._update();
        },

        _create: function () {
            this.wrap = this.element;

            this._setStickyLnks();

            this._scrollOnClick();
        },

        _setStickyLnks: function () {
            var elem = [];

            var labels = this.wrap.hasClass("s-about--faqs") ? this.wrap.find(".s-faqs__title") : this.wrap.find(".strip-caption");

            labels.each(function () {
                elem.push($(this).html());
            });

            for (var i = 0; i < elem.length; i++) {
                this.wrap.find(".b-aside-menu ul").append('<li><a href="#section-' + [i] + '"' + ">" + elem[i] + "</a></li>");
            }

            for (var i = 0; i < elem.length; i++) {
                this.wrap.find(".s-about__dropdown select").append('<option value="section-' + [i] + '"' + ">" + elem[i] + "</option>");
            }
        },

        _scrollOnClick: function () {
            this.wrap.find(".b-aside-menu li a").on("click", function (e) {
                e.preventDefault();
                //  $(document).off("scroll");

                var target = this.hash,
                    target = $(target);

                $("html, body")
                    .stop()
                    .animate(
                        {
                            scrollTop: target.offset().top - 120,
                        },
                        600,
                        "swing"
                    );
            });
        },
    });
})(jQuery);
